import { Button, Card, Col, Form, InputGroup, Row } from 'react-bootstrap';
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import {
    optionsTheme,
    theme,
    tradeControl,
} from '../../../styles/react-select-config';
import useSellers from '../../../hooks/useSellers';
import { EditManySellersOptions } from '../../../constants/editManySeller';
import EditManyModal from './EditManyModal';
import { IEditManyHandler } from '../../../contexts/sellersContext';
import { UseInfiniteQueryResult } from 'react-query';




export default function SellerEditMany({ refetch }: UseInfiniteQueryResult) {
    const { 
        actionToEditForm,
        showEditManyModal,
        showEditManyModalInsertValue,
        setShowEditManyModalInsertValue
    } = useSellers();

    const handleOpenEditMany = () => {
        const action = actionToEditForm.control?.getValues().action;
        if ( action !== null){
            setShowEditManyModalInsertValue(true);
        }
    };
    
    const handleSaveEditMany = async (handler: IEditManyHandler) => {
        await handler.execute();
        setShowEditManyModalInsertValue(false);
        refetch();
    };

    return (
        <Form
            onSubmit={(e) => {
                e.preventDefault();
            }}
        >
            <EditManyModal
                show={showEditManyModalInsertValue}
                onHide={() => setShowEditManyModalInsertValue(false)}
                onSave={() => setShowEditManyModalInsertValue(false)}
                onExecuteHandler={handleSaveEditMany}
            />
            <Row>
                <Col>
                    {showEditManyModal && (
                        <Card className="mb-4 mx-2">
                            <Card.Body>
                                <Card.Title>
                                    <strong>Edição em massa</strong>
                                </Card.Title>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group controlId="formBasicAction">
                                            <Form.Label>Ação</Form.Label>

                                            <Controller
                                                isClearable
                                                className="form-control-nexen"
                                                as={Select}
                                                control={actionToEditForm.control}
                                                name="action"
                                                options={EditManySellersOptions}
                                                styles={{
                                                    control: tradeControl,
                                                    option: optionsTheme,
                                                }}
                                                theme={theme}
                                                placeholder="Selecione..."
                                                defaultValue={null}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={3} className="d-flex align-items-center mt-4">
                                        <Form.Group controlId="formBasicUseFilters" className="w-100">
                                            <Controller
                                                name="useFilters"
                                                control={actionToEditForm.control}
                                                render={(props) => (
                                                    <Form.Check
                                                        type="switch"
                                                        id="useFiltersSwitch"
                                                        label="Atualizar a partir de filtros"
                                                        checked={props.value}
                                                        onChange={(e) => props.onChange(e.target.checked)}
                                                    />
                                                )}
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4} className="d-flex align-items-center mt-2">
                                        <Button variant="outline-primary" onClick={handleOpenEditMany}>
                                            <i className="fas fa-tasks" /> Executar edição em massa
                                        </Button>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    )}
                </Col>
            </Row>
        </Form>
    );
}
